import { css, createGlobalStyle } from "styled-components";

/** Disable non-essential motion when the member requests reduced motion. */
export const registrationReducedMotionStyles = css`
  @media (prefers-reduced-motion: reduce) {
    &,
    *,
    *::before,
    *::after {
      animation: none !important;
      transition: none !important;
      scroll-behavior: auto !important;
    }

    .discovery-spinner {
      opacity: 0.45;
    }
  }
`;

export const RegistrationMotionStyles = createGlobalStyle`
  @media (prefers-reduced-motion: reduce) {
    [data-registration-keyboard="true"],
    [data-registration-keyboard="true"] *,
    [data-registration-keyboard="true"] *::before,
    [data-registration-keyboard="true"] *::after {
      animation: none !important;
      transition: none !important;
      scroll-behavior: auto !important;
    }

    [data-registration-keyboard="true"] .discovery-spinner {
      opacity: 0.45;
    }
  }
`;
